import { ActionIcon, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconSun, IconMoon } from '@tabler/icons-react';

export const ThemeToggle = () => {
  // Drive the icon/color from the resolved scheme (so 'auto' shows the right
  // state), but toggle via setColorScheme based on what's actually visible.
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light');
  const dark = computedColorScheme === 'dark';

  return (
    <ActionIcon
      variant="outline"
      color={dark ? 'yellow' : '#868e96'}
      size="sm"
      aria-label="Переключить тему"
      onClick={() => setColorScheme(dark ? 'light' : 'dark')}
    >
      {dark ? <IconSun size={12} /> : <IconMoon size={12} />}
    </ActionIcon>
  );
};
